import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const SampleNextArrow = props => {
  const { onClick } = props;
  return (
    <div
      id="arrow-next"
      className="arrow-next cursor-pointer absolute"
      style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" width={24} height={24} alt="arrow next" />
    </div>
  );
};

const SamplePrevArrow = props => {
  const { onClick } = props;
  return (
    <div
      id="arrow-prev"
      className="arrow-prev hidden cursor-pointer absolute -left-30"
      style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }}
      onClick={onClick}
    >
      <img src="/images/icons/navbar-arrow.svg" width={24} height={24} alt="arrow prev" />
    </div>
  );
};

export default function SimpleSlider(props) {
  let displayDesktopCount = props.width > 767 ? 3 : 1;
  let l = props.processes.length;

  var settings = {
    infinite: false,
    speed: 300,
    swipe: false,
    slidesToShow: displayDesktopCount,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false,
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
        },
      },
    ],
    afterChange: function (a) {
      if (document.getElementById('arrow-prev')) document.getElementById('arrow-prev').style.display = 'block';

      if (document.getElementById('arrow-next')) document.getElementById('arrow-next').style.display = 'block';

      if (a + displayDesktopCount + 1 == l + 1) {
        if (document.getElementById('arrow-next')) document.getElementById('arrow-next').style.display = 'none';
      }

      if (a == 0) {
        if (document.getElementById('arrow-prev')) document.getElementById('arrow-prev').style.display = 'none';
      }

      var el = document.getElementById('process-row');

      if (el) {
        el.style.width = `${(100 * (a + displayDesktopCount)) / l}%`;
      }
    },
  };
  return (
    <div>
      <div className="relative mb-15">
        <div className="w-full h-2 bg-gray-slider" />
        <div
          id="process-row"
          className="absolute left-0 h-4 bg-purple rounded-5 transition-all transition-500"
          style={{ top: '-1px', width: `${(100 * displayDesktopCount) / l}%` }}
        />
      </div>

      <Slider {...settings} className="process-slider relative z-10">
        {props.processes &&
          props.processes.map((process, index) => (
            <div key={index} className={(index !== 3 ? 'max-w-230' : '') + ' md:max-w-none mr-15 md:mr-30'}>
              <div className={`relative z-10  pr-15 md:pr-23 h-full md:select-text`}>
                <div className={`relative ${index > 2 || index == 0 ? 'pl-0' : ' '} py-0 md:py-23  sm:bg-auto md:bg-auto md:p-0 h-full`}>
                  <p className="relative right-0 top-0 text-48 font-black leading-none text-gray-transparent md:text-pink pr-5 md:pr-0">
                    0{process.index}
                  </p>

                  <p className="text-14 lg:text-16 font-bold md:font-black text-green normal-case md:uppercase mb-23 md:mb-0 max-w-50 md:max-w-none">
                    {process.title}
                  </p>

                  <p className="text-14 max-w-50 md:max-w-none">
                    <span>{process.text}</span>
                  </p>
                </div>
              </div>
            </div>
          ))}
      </Slider>
    </div>
  );
}
